import {
  Circle,
  Grid,
  GridItem,
  Heading,
  HStack,
  Spinner,
  Stack,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import { BackButton, TouchableOpacity } from "components";
import { getSession } from "features/auth/slice";
import { useTranslation } from "languages";
import React from "react";
import { useNavigate } from "react-router-dom";
import { AppLinks } from "tools/navigations";
import { useAppDispatch, useAppSelector } from "tools/store";
import { createAyahNumber, timeCalculator } from "utils/Helpers";
import { getIsArabic } from "../global_slice";
import { setCurrentPage, setSelected } from "../non_persist_slice";
import { useDeleteBookmarkMutation, useGetBookmarksQuery } from "../service";

const Bookmark: React.FC = () => {
  const navigation = useNavigate();
  const dispatch = useAppDispatch();
  const translation = useTranslation();
  const isArabic = useAppSelector(getIsArabic);
  const userData = useAppSelector(getSession);

  const [deleteBookmark, { isLoading: isDeleting }] =
    useDeleteBookmarkMutation();

  const { data, isFetching } = useGetBookmarksQuery(userData?.user?.id || 0, {
    skip: !userData?.user?.id,
  });
  const list =
    data && data?.length > 0
      ? data.map((it: any) => ({ ...it, content: JSON.parse(it?.content) }))
      : [];

  // console.log("=-=-=->>>", list)

  const handleRemoveItem = (index: number) => {
    // const temp = [...list]
    // temp.splice(index, 1)

    // var payload = {
    //     user_id: userData?.user.id,
    //     content: JSON.stringify(obj),
    // };

    // dispatch(setBookmarkList(temp))

    deleteBookmark(index);
  };

  const layoutDirection = useBreakpointValue({ base: "column", md: "row" });

  return (
    <Stack w={"100%"} h={"100%"}>
      <BackButton />

      <Heading px={[4, 10]} pt={2}>
        {translation["bookmark"]}
      </Heading>

      {isFetching || isDeleting ? (
        <Spinner size="xl" position={"absolute"} top={"50%"} left={"50%"} />
      ) : (
        <Stack
          w={"100%"}
          px={[4, 10]}
          pt={[4, 10]}
          pb={[40, 10]}
          overflowY={"scroll"}
          className="mac-scrollbar"
        >
          {!isFetching && list.length === 0 && (
            <Heading
              position={"absolute"}
              top={"50%"}
              left={layoutDirection === "column" ? undefined : "50%"}
            >
              {translation["empty_data"]}
            </Heading>
          )}

          <Grid
            templateColumns={`repeat(${
              layoutDirection === "column" ? "1" : "3"
            }, 1fr)`}
            gap={[2, 6]}
            w={"100%"}
          >
            {list.map((it: any, index: number) => (
              <GridItem
                w="100%"
                key={index}
                bgColor={"secondary.300"}
                p={3}
                rounded={"xl"}
              >
                <TouchableOpacity
                  gap={5}
                  onClick={() => {
                    dispatch(setCurrentPage(it?.content?.page));
                    dispatch(setSelected(it?.content));
                    navigation(AppLinks.DASHBOARD);
                  }}
                >
                  <HStack w={"100%"} justify={"space-between"}>
                    <Text color={"primary.300"}>
                      {isArabic
                        ? it?.content?.surah?.name
                        : it?.content?.surah?.englishName}{" "}
                      {isArabic
                        ? createAyahNumber(it?.content?.surah?.number)
                        : it?.content?.surah?.number}
                    </Text>
                    <Circle size="35px" bg="secondary.350">
                      <Text>
                        {isArabic ? createAyahNumber(index + 1) : index + 1}
                      </Text>
                    </Circle>
                  </HStack>
                  <Text
                    noOfLines={1}
                    dir="rtl"
                    color={"whit?.contente"}
                    fontSize={"lg"}
                  >
                    {it?.content?.text?.replace(
                      "بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ",
                      ""
                    )}
                  </Text>

                  <HStack w={"100%"} justify={"space-between"}>
                    <Text color={"secondary.700"} fontSize={"sm"}>
                      {timeCalculator(new Date(it?.content?.date))}
                    </Text>
                    <HStack gap={4}>
                      <TouchableOpacity
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemoveItem(it?.id);
                        }}
                      >
                        <Text fontSize={"sm"} as={"u"} color={"red"}>
                          {translation["remove"]}
                        </Text>
                      </TouchableOpacity>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                      >
                        <g
                          id="vuesax_linear_archive-tick"
                          data-name="vuesax/linear/archive-tick"
                          transform="translate(0.5 0.5)"
                        >
                          <g id="archive-tick">
                            <path
                              id="Vector"
                              d="M3.86,0A3.869,3.869,0,0,0,0,3.86V17.95c0,1.8,1.29,2.56,2.87,1.69l4.88-2.71a2.118,2.118,0,0,1,1.87,0l4.88,2.71c1.58.88,2.87.12,2.87-1.69V3.86A3.884,3.884,0,0,0,13.5,0Z"
                              transform="translate(3.32 2)"
                              fill="#bf8d46"
                              stroke="#bf8d46"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.5"
                              stroke-dasharray="0 0"
                            />
                            <path
                              id="Vector-2"
                              data-name="Vector"
                              d="M24,0V24H0V0Z"
                              fill="none"
                              stroke="#bf8d46"
                              stroke-width="1"
                              opacity="0"
                            />
                          </g>
                        </g>
                      </svg>
                    </HStack>
                  </HStack>
                </TouchableOpacity>
              </GridItem>
            ))}
          </Grid>
        </Stack>
      )}
    </Stack>
  );
};

export default Bookmark;
